/**
 * PreviewPinButton — the "Live preview" toggle that shows or hides the right
 * panel. Split out of PreviewToolbarControls so the Automation's optimizer
 * pop-up uses the very same button.
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC } from 'react';
import { PanelRightClose, PanelRightOpen } from 'lucide-react';

import { Button } from '@/components/ui/layout/Button';

export interface PreviewPinButtonProps {
  pinned: boolean;
  onToggle: () => void;
}

export const PreviewPinButton: FC<PreviewPinButtonProps> = ({ pinned, onToggle }) => (
  <Button
    type="button"
    variant={pinned ? 'secondary' : 'outline'}
    size="sm"
    className="h-7 gap-1 px-2 text-[10px]"
    onClick={onToggle}
    aria-pressed={pinned}
    aria-label={pinned ? 'Hide live preview panel' : 'Show live preview panel'}
  >
    {pinned ? (
      <PanelRightClose className="h-3 w-3" aria-hidden />
    ) : (
      <PanelRightOpen className="h-3 w-3" aria-hidden />
    )}
    Live preview
  </Button>
);

export default PreviewPinButton;
